import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Security as SecurityProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/security';
import Enum from '@square/dashboard-utilities/utils/enum';
export const PasscodeTimeout = new Enum(Object.keys(SecurityProto.PasscodeTimeout));
export default ProtoBaseModel.extend({
  passcodesEnabled: attr(Boolean),
  allowTeamPasscode: attr(Boolean),
  teamPasscode: attr(String),
  requirePasscodeAfterEachSale: attr(Boolean),
  requirePasscodeWhenBackingOutOfSale: attr(Boolean),
  requirePasscodeWhenBackingOutOfBuyerFacingScreen: attr(Boolean),
  requirePasscodeAfterLogout: attr(Boolean),
  requirePasscodeAfterTimeout: attr(PasscodeTimeout),
  legacyTrackTime: attr(Boolean)
}).reopenClass({
  getDisplayTranslationKeyForPasscodeTimeout(passcodeTimeout) {
    switch (passcodeTimeout) {
      case PasscodeTimeout.NEVER:
        return 'business.devices.profiles.v2.settings.security.requirePasscode.timeout.never';
      case PasscodeTimeout.THIRTY_SECONDS:
        return 'business.devices.profiles.v2.settings.security.requirePasscode.timeout.30Seconds';
      case PasscodeTimeout.ONE_MINUTE:
        return 'business.devices.profiles.v2.settings.security.requirePasscode.timeout.1Minute';
      case PasscodeTimeout.FIVE_MINUTES:
        return 'business.devices.profiles.v2.settings.security.requirePasscode.timeout.5Minutes';
      default:
        return '';
    }
  }
});